import { render, staticRenderFns } from "./DataAccessRestrictionsSettingsList.vue?vue&type=template&id=4e54c8a6&"
import script from "./DataAccessRestrictionsSettingsList.vue?vue&type=script&lang=js&"
export * from "./DataAccessRestrictionsSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports